import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const RouterMap = [
  {
    path: '/',
    hidden:true,
    redirect: '/home/dsx',
  },
  {
    path: '/home',
    component: () => import('@/views/homePage/Index.vue'),
    meta: {
      title: '在线服务'
    }
  },
  {
    path: '/home/dsx',
    component: () => import('@/views/homePage/Index.vue'),
    meta: {
      title: '多时相'
    }
  },
	{
	  path: '/phonehome',
	  component: () => import('@/views/homePage/PhoneIndex.vue'),
	  meta: {
	    title: '在线服务'
	  }
	},
  {
    path: '/specials',
    component: () => import('@/views/homePage/SpecialLayer.vue'),
    meta: {
      title: '专题地图'
    }
  }
]

export default new Router({
  routes: RouterMap
})









// WEBPACK FOOTER //
// ./src/router/index.js